module.exports = __webpack_public_path__ + "img/第3章_2-1_門.jpg";